/**
 * Loại phí
 * nddat1 30/01/2023
 */
export default {
  Balance: 5,
  AddTarget: 10,
};
